import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.SectionC2');
    return (
        <div className={styles.comp}>
            <EcoSectionCommon
                title={t('title')}
                desc={t('desc')}
                lChildren={t('btn1')}
                lHref="https://x.com/EcoFlowJapan"
                lDataLayer={{
                    event: 'uaEvent',
                    event_name: 'share',
                    method: 'Twitter',
                    item_id: 'wave-3-and-glacier-classic',
                }}
            />
            <EcoSpaceSmall />
            <EcoImg
                className="eco-content section-img"
                pc="https://websiteoss.ecoflow.com/upload/image/1745214918096/1080%EF%BC%8A1920%20%EF%BC%88%E5%AE%89%E5%85%A8%E8%8C%83%E5%9B%B41080_1420%EF%BC%89.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1745214918096/1080%EF%BC%8A1920%20%EF%BC%88%E5%AE%89%E5%85%A8%E8%8C%83%E5%9B%B41080_1420%EF%BC%89.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1745214917952/1080%20(3)%201.jpg"
            />
            <EcoSpace />
        </div>
    );
}
